import { Injectable } from "@angular/core";
import { Observable, merge, map, share } from "rxjs";
import { AssessmentTasksService } from "./assessment_tasks.service";
import type { AssessmentTaskMutationEvent } from "./assessment_tasks.service";
import { QuestionResponsesService } from "./question_responses.service";
import { AssessmentTaskScopeChangesService } from "./assessment_task_scope_changes.service";

export type AssessmentTaskInvalidation = AssessmentTaskMutationEvent | {
    kind: "response";
    productLicenseId: number | null;
    affectedRequirements: null;
    taskId: null;
} | {
    kind: "scope";
    productLicenseId: number | null;
    source: "mutation" | "license_refresh";
    affectedRequirements: null;
    taskId: null;
};

@Injectable({ providedIn: "root" })
export class AssessmentTaskInvalidationService {
    private readonly events: Observable<AssessmentTaskInvalidation>;

    constructor(
        private readonly tasks: AssessmentTasksService,
        private readonly responses: QuestionResponsesService,
        private readonly scopeChanges: AssessmentTaskScopeChangesService
    ) {
        this.events = merge(
            this.tasks.watchMutations(),
            this.responses.watchMutationEvents().pipe(map((mutation): AssessmentTaskInvalidation => ({
                kind: "response",
                productLicenseId: mutation.productLicenseId,
                affectedRequirements: null,
                taskId: null
            }))),
            this.responses.watchComplianceStatusRefresh().pipe(map((productLicenseId): AssessmentTaskInvalidation => ({
                kind: "response",
                productLicenseId,
                affectedRequirements: null,
                taskId: null
            }))),
            this.scopeChanges.watchChanges().pipe(map((change): AssessmentTaskInvalidation => ({
                kind: "scope",
                productLicenseId: change.productLicenseId,
                source: change.source,
                affectedRequirements: null,
                taskId: null
            })))
        ).pipe(share());
    }

    watchInvalidations(): Observable<AssessmentTaskInvalidation> {
        return this.events;
    }
}
